import React, { FC } from 'react'
import './TransactionSuccess.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';
import { ITransactionStatus } from 'app_types/transaction/transactionTypes';

const checkIcon = require('app_assets/images/logos/check.png')

interface ITransactionSuccessProps {
  isLoading: boolean
  transaction: ITransactionStatus
  handleGetDetails: () => JSX.Element
}

const TransactionSuccess: FC<ITransactionSuccessProps> = ({
  isLoading,
  transaction,
  handleGetDetails
}) => {


  return (
    <div className='transactions-success--big-container'>
      <LoadingWrapper minHeight='614px' loading={isLoading}>
        <div className='transactions-success--container'>
          <div className='transactions-success--title'>Pago exitoso</div>
          <div className='transactions-success--check-icon-container'>
            <img className='transactions-success--check-icon' src={checkIcon} alt="" />
          </div>
          <div className='transactions-success--subtitle'>Muchas gracias por confiar en nosotros.</div>
          <div className='transactions-success--text'>Tu pedido está siendo procesado. Enviaremos la información de tu compra al correo registrado</div>
          <div className='transactions-success--subtitle'>Información de tu pedido</div>
          <div className='transactions-success--text-container'>
            {handleGetDetails()}
          </div>
          <Link style={{marginTop: 'auto'}} to={routingService.getSecurePath('?section=certifications')}>
            <ButtonComponent variant='secondary' textTransform='none' width='100%' marginTop='20px'>Volver al sitio</ButtonComponent>
          </Link>
        </div>
      </LoadingWrapper>
    </div>
  )
}

export default TransactionSuccess
